import { render } from "./Cajas.vue?vue&type=template&id=8b83174a&scoped=true"
import script from "./Cajas.vue?vue&type=script&lang=js"
export * from "./Cajas.vue?vue&type=script&lang=js"

import "./Cajas.vue?vue&type=style&index=0&id=8b83174a&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\clogistica_front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b83174a"]])

export default __exports__